export default "<p>\r\n  logout works!\r\n</p>\r\n";